import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';
import classNames from 'classnames';
import { Link } from '../Link';
import * as styles from './Agreement.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Agreement = function Agreement(_ref) {
  var agreementAccepted = _ref.agreementAccepted,
    subscriptionAccepted = _ref.subscriptionAccepted,
    onAgreementChange = _ref.onAgreementChange,
    onSubscriptionChange = _ref.onSubscriptionChange;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames(styles['row--first']),
      "data-testid": "row-first",
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: agreementAccepted,
        onChange: onAgreementChange,
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: ["\u041F\u0440\u0438\u043D\u0438\u043C\u0430\u044E \u0443\u0441\u043B\u043E\u0432\u0438\u044F", ' ', /*#__PURE__*/_jsx(Link, {
            href: "/help/about/rules/",
            target: "_blank",
            responsive: true,
            children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F"
          }), ",", ' ', /*#__PURE__*/_jsx(Link, {
            href: "/help/about/36526/",
            target: "_blank",
            responsive: true,
            children: "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438"
          }), ' ', "\u0438", ' ', /*#__PURE__*/_jsx(Link, {
            href: "/legal-documents/soglasie_na_obrabotku_personalnyx_dannyx_razreshennyx_subektom_personalnyx_dannyx_dlya_rasprostraneniya_0",
            target: "_blank",
            responsive: true,
            children: "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0438 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
          })]
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classNames(styles['row--second']),
      "data-testid": "row-second",
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: ["\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C", ' ', /*#__PURE__*/_jsx(Link, {
            href: "/legal-documents/soglasie_na_poluchenie_reklamnyx_rassylok_0",
            target: "_blank",
            responsive: true,
            children: "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u0443\u044E \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443"
          })]
        }),
        checked: subscriptionAccepted,
        onChange: onSubscriptionChange
      })
    })]
  });
};